import { Box, Grid } from "@mui/material";
import {
  DetailViewBox,
  InnerWrapper,
  TitleAndActionBox,
} from "../../common";
import { HeadingText, ParagraphText, UBButton } from "../../../Libraries";
import { Fragment, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { SaleBookNonIdeal } from "../../common/NewNonIdeal";
import { CheckmarkGreenIcon } from "../../../assets/icons/icon";
import { formatNum } from "../../../oscar-pos-core/constants";
import { sentenceCase } from "../../../constants";
import styles from "./TransactionSuccess.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const TransactionSuccess = ({
  detailItems = [],
  successIcon = <CheckmarkGreenIcon width={60} height={60} />,
  title,
  subTitle,
  notFound = false,
  amount = 0,
  primaryButtonText = "",
  primaryButtonClick = () => {},
  commissionPrice,
  BottomCTAS = [],
}) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();

  return (
    <Box className={styles.pageWrapper}>
      <TitleAndActionBox
        data={{
          title: I18n.transaction_detail,
          isBack: true,
          id: "transaction_details",
          onBack: () => navigate(-1),
        }}
      />
      <InnerWrapper
        className={`innerWrapper oneColumnWithBreadcrum`}
      >
        <Box className={styles.content}>
          {!notFound ? (
            <Grid container className={styles.gridContainer}>
              <Grid item md={4}>
                <Box className={styles.iconWrap}>{successIcon}</Box>
                <HeadingText
                  tag="h2"
                  className={"textCenter fontSize24 fontWeight500 newFontColor"}
                >
                  {title || sentenceCase(I18n.transaction_successful)}
                </HeadingText>
                <div className={styles.spacer20} />
                {subTitle ? (
                  <>
                    <ParagraphText
                      align="center"
                      className="fontSize16 newLightColor"
                    >
                      {subTitle}
                    </ParagraphText>
                    <div className={styles.spacer8} />
                  </>
                ) : null}
                <HeadingText
                  tag="h2"
                  className={
                    "fontSize28 fontWeight500 newFontColor textCenter"
                  }
                  align="center"
                >
                  Rs. {formatNum(amount) ?? 0}
                </HeadingText>
                {detailItems.length ? (
                  <DetailViewBox items={detailItems} />
                ) : null}
                {commissionPrice ? (
                  <Fragment>
                    <Box marginTop={"24px"} />
                    <ParagraphText
                      className={
                        "foundationGreenColor fontSize14 textCenter"
                      }
                    >
                      {`${sentenceCase(I18n.commission_earned)}: Rs. ${formatNum(
                        commissionPrice,
                      )}`}
                    </ParagraphText>
                  </Fragment>
                ) : null}
                {primaryButtonText ? (
                  <UBButton
                    id="transaction_success_primary_btn"
                    title={primaryButtonText}
                    className={`${styles.primaryBtn} ubPrimaryButton fontSize14 textUppercase`}
                    onClick={() => {
                      triggerLogEvent(analytics, "transaction_success_primary_cta_clicked", { button_text: primaryButtonText });
                      primaryButtonClick();
                    }}
                  />
                ) : null}
                {BottomCTAS.length ? (
                  <Box className={styles.bottomActions}>
                    {BottomCTAS.map((item, index) => (
                      <UBButton
                        key={index}
                        id={item?.id || `transaction_success_secondary_btn_${index}`}
                        title={item?.title}
                        loading={item?.loading}
                        disabled={item?.disabled ?? item?.loading}
                        iconComponent={item?.iconComponent}
                        className={item?.className}
                        onClick={() => {
                          triggerLogEvent(analytics, "transaction_success_secondary_cta_clicked", { button_id: item?.id || `btn_${index}`, button_text: item?.title });
                          item?.onClick?.();
                        }}
                      />
                    ))}
                  </Box>
                ) : null}
              </Grid>
            </Grid>
          ) : (
            <SaleBookNonIdeal title="Not Found Transaction" />
          )}
        </Box>
      </InnerWrapper>
    </Box>
  );
};

export default TransactionSuccess;
